import ownerDocument from './ownerDocument';
/**
 * Returns the owner window of a given element.
 * 
 * @param node the element
 */

export default function ownerWindow(node) {
  var doc = ownerDocument(node);
  return doc && doc.defaultView || window;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/dom-helpers/esm/ownerWindow.js
// module id = 560
// module chunks = 136